import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyAuditLog extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} pageTitle={"Audit Log"} formname={"table_73"} customClass={"field-customization-container org-container"} customFrameClass={"audit-log-container"}/>
        );
    }
}

export default LegacyAuditLog;
